import React, { useEffect, useState } from "react"
import { Modal, Button, Input, Select, Radio, Col, Row, Form, Tag, Typography, Space, message } from "antd"
import styled from "@emotion/styled"
import { useDictModel } from "@/views/base/dict/dictModel"
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel"
import { reportBillService } from "../reportBill/reportBillService"

const { Option } = Select
const { Text } = Typography

const Conetnt = styled.div`
    .ant-modal-close {
        display: none
    }
`

const ChooseVehicle: React.FC<any> = (props) => {
    const [form] = Form.useForm()
    const { visible, vehicleData, onSuc, onClose } = props
    const { getSelectedDictOne } = useDictModel();
    const { shopAndOrg: { shopCode, shopId, shopName } } = useGlobalModel();
    //可能车型
    const [possible, setPossible] = useState<boolean>(false);
    const [possibleList, setPossibleList] = useState<any>([]);

    const onSubmit = () => {
        form.validateFields().then((res) => {
            onSuc(res)
        })
    }



    useEffect(() => {
        form.setFieldsValue({
            ...vehicleData,
        })
        findCustomer()
    }, [vehicleData, form])

    const handleChangebrandName = (value: string, option: any) => {
        form.setFieldsValue({
            confirmBrandName: option.info.label,
            confirmBrandCode: option.info.value,
        })
    }

    const handleChangeVehicleType = (value: string, option: any) => {
        form.setFieldsValue({
            confirmVehicleTypeName: option.info.label,
            confirmVehicleTypeCode: option.info.value,
        })
    }

    const findCustomer = async () => {
        let params = {
            customerName: vehicleData.confirmCustomerName,
            pageNum: 1,
            pageSize: 20,
            shopCode: shopCode,
            shopId: shopId,
            shopName: shopName,
            shopType: 1,
        };
        try {
            const result = await reportBillService.customerQueryInfo(params);
            if (result?.retData?.records?.length < 1) {
                form.setFieldsValue({
                    customerChoose: 2
                })
                message.warning('没有查询到车辆详情信息');
                return;
            }
            let vehicleData = result?.retData?.records[0] ?? {};
            form.setFieldsValue({
                existCustomerName: vehicleData?.customerName,
                contact: vehicleData?.contact,
                phone: vehicleData?.phone,
                customerChoose: 1
            })


        } catch (error) {
            console.error('获取客户信息失败', error);
            message.warning('查询客户信息失败');
        }
    }

    const formItemLayout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    }

    return (
        <Conetnt>
            <Modal
                title="确认信息"
                width={500}
                open={visible}
                visible={visible}
                onCancel={() => onClose(false)}
                footer={[
                    <Button type="primary" onClick={onSubmit} key="submit">
                        确认
                    </Button>,
                ]}
            >
                <Form form={form} {...formItemLayout}>
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                                name="confirmVehicleCode"
                                label="车牌牌照"
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入车辆牌照",
                                    },
                                    {
                                        pattern: /^[\u4E00-\u9FA5][\da-zA-Z]{6,7}$/,
                                        message: "请输正确的车辆牌照",
                                    },
                                ]
                                }
                            >
                                <Input placeholder="请输入车牌号" />
                            </Form.Item>
                            <Form.Item
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                                name="confirmBrandName"
                                label="车辆品牌"
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择车辆品牌",
                                    },
                                ]}
                            >
                                <Select showSearch placeholder="请选择车辆品牌" onSelect={handleChangebrandName} style={{ width: '100%' }}>
                                    {getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND).map((item: any) => (
                                        <Option value={item.label} key={item.value} info={item}>
                                            {item.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                                name="confirmVehicleTypeName"
                                label="车辆类型"
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择车辆类型",
                                    },
                                ]}
                            >
                                <Select showSearch placeholder="请选择车辆类型" onSelect={handleChangeVehicleType} style={{ width: '100%' }}>
                                    {getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE).map((item: any) => (
                                        <Option value={item.label} key={item.value} info={item}>
                                            {item.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                                name="confirmVinCode"
                                label="vin 码"
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                                name="existCustomerName"
                                label="现有客户"
                            >
                                <Input disabled={true} />
                            </Form.Item>
                            <Form.Item
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                                name="confirmCustomerName"
                                label="识别名称"
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入识别名称",
                                    },
                                ]}
                            >
                                <Input placeholder="请输入识别名称" />
                            </Form.Item>
                            <Form.Item hidden name="confirmBrandCode">
                                <Input />
                            </Form.Item>
                            <Form.Item hidden name="confirmVehicleTypeCode">
                                <Input />
                            </Form.Item>
                            <Form.Item hidden name="contact">
                                <Input />
                            </Form.Item>
                            <Form.Item hidden name="phone">
                                <Input />
                            </Form.Item>
                            <Form.Item
                                style={{ marginLeft: 60 }}
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 20 }}
                                name="customerChoose"
                            >
                                <Radio.Group >
                                    <Space direction="vertical">
                                        <Radio value={1}>使用现有客户名称</Radio>
                                        <Radio value={2}>更新为识别的客户名称</Radio>
                                    </Space>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </Conetnt>
    )
}

export default ChooseVehicle
